export const highlightSearchMatch = (text, search) => {
    if (!search)
        return [{ text, isBold: false }];
    const searchWords = search.trim().split(/\s+/);
    const pattern = searchWords.map((word) => `(${word})`).join('|');
    const regex = new RegExp(pattern, 'gi');
    const parts = text.split(regex);
    return parts
        .filter((part) => part) // usuwa puste stringi
        .map((part) => ({
        text: part,
        isBold: searchWords.some((word) => part.toLowerCase() === word.toLowerCase()),
    }));
};
